// Moved to @livingsyncs/ui (frontend split epic, Phase 2 Task 2.2). Shim kept
// so nothing importing the old path breaks during the transition.
// Real function declarations, not reference copies — see hooks/useAuth.ts.
import * as _accessModule from "@livingsyncs/ui";

export function can(...args: Parameters<typeof _accessModule.can>) {
  return _accessModule.can(...args);
}
export function canAny(...args: Parameters<typeof _accessModule.canAny>) {
  return _accessModule.canAny(...args);
}
export function canAll(...args: Parameters<typeof _accessModule.canAll>) {
  return _accessModule.canAll(...args);
}
export function passesAccess(
  ...args: Parameters<typeof _accessModule.passesAccess>
) {
  return _accessModule.passesAccess(...args);
}
